import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const steps = [
  {
    step: '01',
    title: 'Know who is at risk',
    description: 'Surface the customers with meaningful churn risk.',
    detail: 'Risk scoring, account signals, portfolio prioritization.',
    color: '#00b9ff',
  },
  {
    step: '02',
    title: 'Know why',
    description: 'Understand what is driving the risk.',
    detail: 'Behavioral factors, billing signals, account-level explanations.',
    color: '#ffbe00',
  },
  {
    step: '03',
    title: 'Know what action to take',
    description: 'Get a recommended response for the risk identified.',
    detail: 'Recommended actions, signals, task/workflow handoff.',
    color: '#00d688',
  },
];

export default function MechanismSection() {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-14">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight">
            Here&apos;s how ChurnSignal turns data into churn-risk intelligence your team can act on
          </h2>
        </LandingReveal>

        <div className="landing-flow-grid grid md:grid-cols-3 gap-6 mb-12">
          {steps.map((item, index) => (
            <LandingReveal
              key={item.step}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <div className="landing-flow-step landing-card p-6 md:mr-6 h-full">
                <span className="text-sm font-bold tracking-widest mb-3 block" style={{ color: item.color }}>
                  {item.step}
                </span>
                <h3 className="text-xl font-bold text-primary font-secondary mb-3">{item.title}</h3>
                <p className="text-secondary leading-relaxed mb-4">{item.description}</p>
                <p className="text-sm text-muted leading-relaxed">{item.detail}</p>
              </div>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal>
          <p className="text-center text-lg md:text-xl font-semibold text-primary font-secondary">
            So you can prioritize the customers who need your attention most.
          </p>
        </LandingReveal>
      </div>
    </section>
  );
}
